import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";

export class SequenceEndStep extends FlowStepData {
    readonly __type: string = "sequence_end_step";
    paths: string[] = ["link"];
    hiddenEndStep: boolean = true;

    constructor() {
        super();
        this.name = "Sequence End Step";
    }

    getStorageData(): object {
        let data = super.getStorageData();

        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        this.hiddenEndStep = true;
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return this.paths.map((value) => {
            return new MultiExecutableOutputDefinition(value);
        });
    }
}
